// removed by extract-text-webpack-plugin
module.exports = {"root":"QuoteAttribution__root--vrUkY","centered":"QuoteAttribution__centered--3ix6X","bounce":"QuoteAttribution__bounce--1rNaU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/QuoteAttribution/QuoteAttribution.css
// module id = ./src/components/Library/QuoteAttribution/QuoteAttribution.css
// module chunks = 4